<template>
  <div class="contract-new-list-container">
    <!-- 查询条件 -->
    <el-card class="search-wrapper">
      <div slot="header" class="flex justify-between">
        <span>合同查询</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            v-model.trim="searchForm.contractId"
            placeholder="合同编号"
            clearable
          />
        </el-col>
        <el-col :span="6">
          <el-select
            v-model="searchForm.templateCode"
            placeholder="请选择合同来源"
            clearable
            style="width: 100%"
          >
            <el-option
              label="房屋租赁协议模板（装修抵租金.不含采暖费版本）"
              value="houseRent"
            ></el-option>
            <el-option
              label="光谷房屋租赁协议最新版本"
              value="houseRentNew"
            ></el-option>
            <el-option
              label="房屋租赁协议模板（终版.含采暖费）"
              value="houseRentHeating"
            ></el-option>
            <el-option
              label="房屋租赁协议模板（终版.不含采暖费版本）"
              value="houseRentNotHeating"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input
            v-model.trim="searchForm.partyBName"
            placeholder="乙方名称"
            clearable
          />
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="handleSearch">
            <i class="el-icon-search"></i>
            查询
          </el-button>
          <el-button @click="handleReset">
            <i class="el-icon-refresh"></i>
            重置
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- 合同信息列表 -->
    <el-card class="list-wrapper">
      <div slot="header" class="flex justify-between">
        <span>合同缴费信息列表</span>
        <!-- 导出按钮 -->
        <el-button type="primary" size="small" @click="exportContractNew">
          导出
        </el-button>
      </div>

      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column prop="contractId" label="合同编号" align="center" />
        <el-table-column prop="houseName" label="房屋名称" align="center" />
        <el-table-column prop="houseAddress" label="房屋地址" align="center" />
        <el-table-column prop="partyBName" label="乙方名称" align="center" />
        <el-table-column
          prop="partyBContact"
          label="乙方联系人"
          align="center"
        />
        <el-table-column
          prop="partyBPhone"
          label="乙方联系电话"
          align="center"
        />
        <el-table-column prop="rent" label="租金（大写）" align="center" />
        <el-table-column prop="moonTotals" label="租赁" align="center" />
        <el-table-column prop="houseArea" label="房屋面积" align="center" />
        <el-table-column prop="buildingUsage" label="建筑用途" align="center" />
        <el-table-column prop="signDate" label="合同签订日期" align="center" />

        <!-- 是否缴费 - el-switch -->
        <el-table-column label="是否缴费" align="center" width="200">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.payStatus"
              active-value="1"
              inactive-value="0"
              active-text="已缴费"
              inactive-text="未缴费"
              @change="handlePaySwitchChange(scope.row)"
            />
          </template>
        </el-table-column>

        <!-- 状态列 -->
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span :class="scope.row.state === 'Q' ? 'text-red' : 'text-green'">
              {{ scope.row.state === "Q" ? "退租" : "正常" }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleViewDetail(scope.row)">
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="pagination.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <!-- 费用详情弹窗 -->
    <ContractNewDetail
      :contractId="currentContractId"
      :visible.sync="detailVisible"
    />
  </div>
</template>

<script>
import {
  queryContractNew,
  updateContractNew,
} from "@/api/contract/newContractManageApi";
import { exportReportFee } from "@/api/report/reportProficientApi";
import { getCommunityId } from "@/api/community/communityApi";
import ContractNewDetail from "@/components/fee/contractNewDetail";

export default {
  name: "ContractNewList",
  components: {
    ContractNewDetail,
  },
  data() {
    return {
      loading: false,
      searchForm: {
        contractId: "",
        templateCode: "",
        partyBName: "",
        filePath: "1",
      },
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
      detailVisible: false,
      currentContractId: "",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      try {
        this.loading = true;
        const params = {
          page: this.pagination.current,
          row: this.pagination.size,
          ...this.searchForm,
          communityId: getCommunityId(),
        };
        const res = await queryContractNew(params);
        this.tableData = res.data || [];
        this.pagination.total = res.total || 0;
      } catch (error) {
        this.$message.error("获取合同信息失败");
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.pagination.current = 1;
      this.getList();
    },
    handleReset() {
      this.searchForm = {
        contractId: "",
        templateCode: "",
        partyBName: "",
        filePath: "1",
      };
      this.handleSearch();
    },
    handleSizeChange(val) {
      this.pagination.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getList();
    },
    handleViewDetail(row) {
      this.currentContractId = row.contractId;
      this.detailVisible = true;
    },

    // 缴费状态开关切换
    handlePaySwitchChange(row) {
      const text = row.payStatus === "1" ? "已缴费" : "未缴费";
      this.$confirm(
        `是否确认将合同【${row.contractId}】设置为【${text}】？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        },
      )
        .then(() => {
          this.updatePayStatus(row);
        })
        .catch(() => {
          row.payStatus = row.payStatus === "1" ? "0" : "1";
          this.$message.info("已取消操作");
        });
    },

    // 调用接口更新缴费状态
    async updatePayStatus(row) {
      try {
        await updateContractNew({
          contractId: row.contractId,
          payStatus: row.payStatus,
        });
        this.$message.success("状态更新成功");
      } catch (error) {
        row.payStatus = row.payStatus === "1" ? "0" : "1";
        this.$message.error("更新失败");
      }
    },

    // 导出合同缴费信息
    async exportContractNew() {
      try {
        const params = {
          ...this.searchForm,
          communityId: getCommunityId(),
          pagePath: "contractNewExport",
        };
        const res = await exportReportFee(params);
        this.$message.success("导出任务已提交，请到下载中心查看");
        if (res.code === 0) {
          this.$router.push("/pages/property/downloadTempFile?tab=下载中心");
        }
      } catch (error) {
        console.error("导出失败:", error);
        this.$message.error("导出失败，请稍后重试");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contract-new-list-container {
  padding: 20px;

  .search-wrapper {
    margin-bottom: 20px;

    .el-row {
      margin-bottom: -20px;
    }

    .el-col {
      margin-bottom: 20px;
    }
  }

  .list-wrapper {
    .el-pagination {
      margin-top: 20px;
      text-align: right;
    }
  }

  ::v-deep .text-red {
    color: #f56c6c;
    font-weight: 500;
  }
  ::v-deep .text-green {
    color: #67c23a;
    font-weight: 500;
  }
}
</style>
